import * as Yup from 'yup';

import { ResolvableBooleanSchema } from '../../ResolvableField/schemas/resolvable-boolean.schema';

export const ResolvableServiceUsageSettingsSchema = Yup.object().shape({
  showAmountsInQuotation: ResolvableBooleanSchema.required('Paramètre requis'),
  showCostsInQuotation: ResolvableBooleanSchema.required('Paramètre requis'),
  showMaterialsInQuotation:
    ResolvableBooleanSchema.required('Paramètre requis'),
  showQuantitiesInQuotation:
    ResolvableBooleanSchema.required('Paramètre requis'),
});
